import React from 'react';
import { pick } from 'ramda';
import { useMyAccountSidebarSelector } from 'js/store/hooks';

import { HomePage } from 'js/components/main/MyAccountSidebar/components/Content/components/HomePage';
import { PortalPage } from 'js/components/main/MyAccountSidebar/components/Content/components/PortalPage';
import { SidebarTabs } from './components/SidebarTabs';

import style from './Content.scss';

export const Content = () => {
    const { isOpened, portalPageURL } = useMyAccountSidebarSelector(pick(['isOpened', 'portalPageURL']));
    const containerClasses = [style.content, 'sidebar-content-wrapper', ...portalPageURL ? [style.showPage] : []].join(' ');

    return (
        <>
            <div className={containerClasses}>
                {portalPageURL && <SidebarTabs path={portalPageURL} />}
                {isOpened && (
                    portalPageURL ? <PortalPage portalPageURL={portalPageURL} /> : <HomePage />
                )}
            </div>
        </>
    );
};
